import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from 'recharts';
import Nav from './Nav';
import Chatbot from '../com/Chatbot';

const Visualres = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  console.log('Component rendered. Location state:', location.state);

  useEffect(() => {
    console.log('useEffect triggered. Location state:', location.state);
    
    if (location.state?.serverData?.review_summary) {
      const reviewData = location.state.serverData.review_summary;
      console.log('Review data before setting:', reviewData);
      
      // Only set data if it's different from current data
      setData(prevData => {
        if (JSON.stringify(prevData) !== JSON.stringify(reviewData)) {
          console.log('Setting new data');
          return reviewData;
        }
        console.log('Data unchanged, keeping previous state');
        return prevData;
      });
    }
  }, [location.state]);

  console.log('Current data state:', data);

  if (!data || !data.barChartData || !data.pieChartData) {
    console.log('Data not ready yet:', data);
    return null;  // Return nothing while loading
  }

  console.log('Rendering charts with data:', data);

  const colors = ['#00C49F', '#ed133b', '#0088FE', '#FFBB28', '#FF8042', '#AF19FF'];

  return (
    <>
    <Nav/>
    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '20px' }}>
      {/* Bar Chart Section */}
      <div style={{ textAlign: 'center' }}>
        <h3>Bar Chart</h3>
        <div className='mb-40px'>
        <BarChart
          width={700}
          height={400}
          data={data.barChartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
          
        >
          <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="name" 
              angle={-40} 
              textAnchor="end"
              interval={0}
              height={60}
            />
          <XAxis dataKey="name" />
          <YAxis />
          
          <Tooltip />
          <Bar
            dataKey="barValue"
            fill="#8884d8"
            animationBegin={0}
            animationDuration={2000}
            animationEasing="ease-out"
          />
        </BarChart >
       
        </div>
       
        <div style={{ marginTop: '40px' }}> {/* Add margin above text */}
          
      <p>The bar chart illustrates the performance of different aspects</p>
    </div>
       
      </div>

      {/* Pie Chart Section */}
      <div style={{ textAlign: 'center' }}>
        <h3>Pie Chart</h3>
        <PieChart width={400} height={400}>
          <Pie
            data={data.pieChartData}
            dataKey="pieValue"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={120}
            innerRadius={60}
            fill="#8884d8"
            label
            isAnimationActive={true}
            animationBegin={0}
            animationDuration={2000}
            animationEasing="ease-in-out"
          >
            {data.pieChartData.map((entry, index) => (
              <Cell key={`cell - ${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Legend />
        </PieChart>
        
        <p>The pie chart showing satisfaction levels of Users</p>
      </div>
      <Chatbot/>
    </div>
    </>
  );
};

export default Visualres;
